import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

export const formatBidValue = (i18n, data, currencyCode) => {
  if (!data) {
    return i18n.getString(_TL_('No bid value'));
  }

  return `${i18n.getCurrencySymbol(currencyCode)}${data} ${currencyCode}`;
};

export const BidValue = ({ data, currencyCode }) => {
  const i18n = useContext(I18nContext);

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Bid value') }}>
      <Text>{formatBidValue(i18n, data, currencyCode)}</Text>
    </PropertyRow>
  );
};

BidValue.propTypes = {
  data: PropTypes.string,
  currencyCode: PropTypes.string,
};

BidValue.defaultProps = {
  data: '',
  currencyCode: 'USD',
};
